import React from "react"
import { graphql } from "gatsby"
import ReactMarkdown from "react-markdown"
import { GatsbyImage, getSrc } from "gatsby-plugin-image";
import { BgImage } from "gbimage-bridge"
import { FaEnvelope } from "react-icons/fa"
import LayoutGeneric from "../components/LayoutGeneric"
import Seo from "../components/Seo";
import {
  AiOutlineSafetyCertificate,
} from "react-icons/ai"
// import { partners, partnerCategories } from "../components/partners/partners"

export default function Company({data}) {

  const partners = data.partners.nodes;
  const partnerCategories = data.partnerCategories.nodes;
  const contacts = data.contacts.nodes;
  const strapiPageCompany = data.strapiPageCompany;
  // console.log(partners, partnerCategories);
  // console.warn(strapiPageCompany);

  return (
    <LayoutGeneric title={strapiPageCompany.info.title} subtitle={strapiPageCompany.info.subtitle} image={strapiPageCompany.info.image.childImageSharp.gatsbyImageData} testimonial={10} bookDemo={strapiPageCompany.bookDemo}>

      <Seo 
      title={(strapiPageCompany.SEO && strapiPageCompany.SEO.title) ? strapiPageCompany.SEO.title : strapiPageCompany.info.title}
      description={(strapiPageCompany.SEO && strapiPageCompany.SEO.description) ? strapiPageCompany.SEO.description : undefined }
      />

    {
      strapiPageCompany.overview.map((item, i)=>{
        if (item.component === "page-paragraph-title") return (<div key={i} className="gs-company-section df mb2">
        <div className="gs-company-section-col fl1">
          <h2 className="">
            <div className="mb05">{item.title}</div> 
            <div className="gs-products-item__hr"></div>
          </h2>
        </div>
        <div className="gs-company-section-col fl3">
          <ReactMarkdown source={item.text} linkTarget="_blank"/>
        </div>
      </div>)
      else if (item.component === "page-paragraph-image") return (
          <div key={i} className="gs-news-item-long">
            <BgImage image={item.image.childImageSharp.gatsbyImageData} className="gs-news-item-long__pic">
            </BgImage>
            <div className="gs-news-item-long__text">
            <ReactMarkdown source={item.text} linkTarget="_blank" className="gs-news-item-long__desc"/>
            </div>
          </div>
        );
      else if (item.component === "page-title") return (
            <header key={i} className="gs-sect-header tac">
              <h2 className="">{item.text}</h2>
            </header>
        )
      else if (item.component === "page-subtitle") return (
            <h3 key={i} className="">{item.text}</h3>
        )
      else if (item.component === "page-paragraph") return (
        <div key={i} className="gs-company-section">
              <ReactMarkdown source={item.text} linkTarget="_blank"/>
        </div>
        )
      else if (item.component === "page-milestones") return (
        <div key={i} className="gs-company-section">
          <ul className="gs-company-milestones">
          {
            strapiPageCompany.milestones.map((stone, j)=>{
              return(
              <li key={j} className="gs-company-milestone">
                <div className="gs-company-milestone__in">
                  <ReactMarkdown source={stone.text} linkTarget="_blank"/>
                </div>
              </li>)
            })
          }
          </ul>
        </div>
        )
      else if (item.component === "page-partners") return (
          <div key={i} className="gs-company-partners-categories df fww mb4">
            {
              partnerCategories.map((category, j)=>{
                return (
                  <div  key={j} className="gs-company-partners-category">
                        <h3 className="gs-company-partners-category-title">
                        <div className="">{category.name}</div>
                          {/* <div className="gs-products-item__hr"></div> */}
                        </h3>
                        <div className="gs-company-partners-list df fww">
                          {
                            partners.filter((partner)=>partnerCategoriesInclude(partner.category, category.name)).map((partner)=>{
                              return (
                                <a href={partner.url} key={partner.name} title={partner.name} target="_blank" rel="noreferrer" className="gs-company-partner">
                                            <img src={getSrc(partner.logo)} alt={partner.name}/>
                                        </a>
                              );
                            })
                          }
                        </div>
                      </div>
                );
                  })
                }
              </div>
        );
      else if (item.component === "page-patents") return (
        <div key={i} className="gs-company-patents df fl1 fww mb4">
          {
            strapiPageCompany.patents.map((patent, j)=>{
              return(
                <div key={j} className="gs-company-patent tac">
                  <AiOutlineSafetyCertificate className="gs-company-patent-icon"/>
                  <br></br>
                  <span>{patent.text}</span>
                  </div>
                )
            })
          }
        </div>
        )
      else return <div key={i}>unknown component</div>
      })
    }
    
      <header className="gs-sect-header tac">
        <h1 className="">COMPANY MANAGEMENT</h1>
      </header>
      <div className="gs-contact-items">

        {
        contacts
        .map((contact)=>{
        return (
          <div key={contact.id} className="gs-testim-card">
              <div className="gs-testim-card-image">
              <GatsbyImage
                image={contact.image.childImageSharp.gatsbyImageData}
                alt=""
                className="gs-testim-card-pic" />
              </div>
              <div className="gs-testim-card-content">
                <div className="gs-testim-card-author">
                  <h3 className="gs-testim-card-author-name">{contact.name}</h3>
                  <h4 className="gs-testim-card-author-position fw300">{contact.position}</h4>
                  <a href={"mailto:" + contact.email} className="gs-testim-card-link">
                    <FaEnvelope className="gs-footer-link__icon" />
                    <span className="gs-testim-card-link__text">{contact.email}</span>
                  </a>
                </div>
              </div>
            </div>
        );
        })
        }

        </div>
    </LayoutGeneric>
  );
  function partnerCategoriesInclude(cats, name){
    for (let i=0; i<cats.length; i++){
      if (cats[i].name === name) return true;
    }
    return false;
  }
}

export const query = graphql`
  {
    strapiPageCompany {
      id
      info {
        image {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
        title
        subtitle
        slug
      }
      SEO {
        title
        description
      }
      overview {
        component
        image {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
        imageCaption
        text
        title
        id
      }
      milestones {
        text
      }
      patents {
        text
      }
      bookDemo {
        title
        text
        buttonText
      }
    }
    partners: allStrapiPartners {
      nodes {
        id
        name
        url
        logo {
          childImageSharp {
            gatsbyImageData(width: 200, placeholder: BLURRED, layout: FIXED)
          }
        }
        category {
          name
        }
      }
    }
    partnerCategories: allStrapiPartnerCategories {
      nodes {
        name
        id
      }
    }
    contacts: allStrapiContacts(
      sort: { fields: orderInContacts }
      filter: { displayInManagement: { eq: true } }
    ) {
      nodes {
        id
        name
        position
        area
        email
        image {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
      }
    }
  }
`
